import React, { useEffect, useState } from 'react';
import Box from '@material-ui/core/Box';
import List from '@material-ui/core/List';
import ListSubheader from '@material-ui/core/ListSubheader';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import Checkbox from '@material-ui/core/Checkbox';
import Spin from 'components/common/Spin';
import { API } from 'aws-amplify';

const Recipients = ({ recipients, delivery_type, excluded, setExcluded }) => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {

    if (!recipients.type || !recipients.filters || !recipients.filters.length) return;

    setLoading(true);

    const payload = {...recipients};
    delete payload.exclude_users;

    API.post('api', '/users/filter_recipients', {
      body: { recipients: payload, delivery_type },
    })
      .then((resp) => {
        setUsers(resp);
        if (excluded && excluded.length) {
          setExcluded(excluded.filter(id => resp.some(u => u.user_id === id)));
        }
      })
      .finally(() => setLoading(false));
  }, [recipients, delivery_type]);

  const onCheckBoxChange = (e, user) => {
    const { checked } = e.target;
    const items = excluded || [];
    if (checked) {
      setExcluded([...items.filter((i) => i !== user.user_id)]);
    } else {
      items.push(user.user_id);
      setExcluded([...items]);
    }
  };

  return (
    <Box maxHeight={300} overflow="auto" bgcolor="#eee">
      <Spin spinning={loading}>
        <List
          dense
          disablePadding
          subheader={<ListSubheader disableSticky>{users.length} recipients. Uncheck to exclude.</ListSubheader>}
        >
          {users.map((user) => (
            <ListItem dense key={user.user_id}>
              <ListItemText
                primary={`${user.name} ${user.last_name} - ${user.user_type}`}
                primaryTypographyProps={{
                  fontWeight: 400,
                }}
              />
              <ListItemSecondaryAction>
                <Checkbox
                  checked={!excluded?.includes(user.user_id)}
                  color="primary"
                  onChange={(e) => onCheckBoxChange(e, user)}
                />
              </ListItemSecondaryAction>
            </ListItem>
          ))}
        </List>
      </Spin>
    </Box>
  );
};

export default Recipients;
